<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useBachelorDegree } from '../../model/additional-questions/bachelor-degree.hooks'
import { yesNoOptions } from '../../config/additional-questions'

defineOptions({
  name: 'BachelorDegree',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setBachelorDegree,
} = useBachelorDegree()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in yesNoOptions"
      :key="option.value.toString()"
      :mode="mode"
      :checked="tutorApplicationStore.form.hasBachelorDegree === option.value"
      :label="option.label"
      @click="setBachelorDegree(option.value)"
    />
  </FormRow>
</template>
